import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IActivityLog } from "@/models/activity-log.entity";
import { MrfiktivActivityLogControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import sharedActivityLogService from "@/services/shared/sharedActivityLogService";

/**
 * Pages the activity log for the inbox of the logged-in user.
 *
 * Its own provider instance, so the pagination cursor of the inbox is independent of the ones the
 * activity timelines of resource views use.
 */
export const ActivityInboxPageDataProvider = new (class extends AbstractPageDataProvider<
  IActivityLog,
  MrfiktivActivityLogControllerFindAllParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivActivityLogControllerFindAllParamsGen): Promise<IPageViewModel<IActivityLog>> {
    const res = await sharedActivityLogService.getAllForPartner({ ...query });

    return { meta: res.meta, data: (res.data || []) as IActivityLog[] };
  }
})();
